import React from 'react';
import { FadeIn } from './FadeIn';
import { Sparkles } from 'lucide-react';
export function UniqueMethod() {
  return <section className="bg-kitchen-brown py-14 md:py-24 px-5 md:px-12 lg:px-24 text-kitchen-white" data-id="element-144">
      <div className="max-w-4xl mx-auto text-center" data-id="element-145">
        <FadeIn data-id="element-146">
          <div className="inline-flex items-center justify-center p-3 bg-kitchen-amber/20 rounded-full mb-4 md:mb-6" data-id="element-147">
            <Sparkles className="w-7 h-7 md:w-8 md:h-8 text-kitchen-amber" data-id="element-148" />
          </div>
          <h2 className="font-lora text-2xl md:text-5xl font-bold mb-5 md:mb-8" data-id="element-149">
            Presentamos:{' '}
            <span className="text-kitchen-amber" data-id="element-150">
              El Sistema de Venta Anticipada
            </span>
            <span className="block text-xl md:text-3xl mt-2 font-normal opacity-90" data-id="element-151">
              (Pre-Sold Method)
            </span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-152">
          <div className="bg-white/5 p-6 md:p-12 rounded-2xl border border-white/10 backdrop-blur-sm" data-id="element-153">
            <p className="font-nunito text-lg md:text-2xl leading-relaxed mb-4 md:mb-6" data-id="element-154">
              Con este método,{' '}
              <strong className="text-kitchen-amber font-bold" data-id="element-155">
                nunca enciendes la estufa si el plato no está ya vendido.
              </strong>
            </p>
            <p className="font-nunito text-base md:text-xl text-white/80 leading-relaxed" data-id="element-156">
              Aprendes a recolectar pedidos antes de gastar un solo dólar en el
              supermercado, eliminando el riesgo de pérdida y asegurando tu
              ganancia neta desde el minuto uno.
            </p>
            <div className="mt-6 pt-6 md:mt-8 md:pt-8 border-t border-white/20" data-id="element-157">
              <p className="font-lora text-xl md:text-3xl font-bold text-kitchen-terracotta" data-id="element-158">
                No es cocina, es logística de efectivo.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}